import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { doGetJoinedDomainsByUserId } from '../../redux/actions/domain'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import DomainDetailModal from './modals/domain-detail'
import DomainInviteModal from './modals/domain-invite'

import { Table } from 'rsuite'
import { capitalizeFirstCharacter, checkIsAdminOrModerator } from '../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, users = [], ...props }) => {
  if (dataKey === 'status') {
    rowData[dataKey] = capitalizeFirstCharacter(rowData?.userRole?.role?.name)
  }
  return (
    <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
      {dataKey === 'serialNo' ?
        (props?.rowKey + 1)
        :
        rowData[dataKey]
      }
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, onView, onInvite, isAdminOrModerator, ...props }) => {
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="d-flex gap-2">
        {
          (isAdminOrModerator && rowData?.userRole?.isActive) &&
          (
            <button type="button" className="h4 pt-2 pb-2 rounded mb-0 bg-gray text-white width-100" onClick={() => onInvite(rowData)}>Invite</button>
          )
        }
        <button type="button" className={`h4 pt-2 pb-2 rounded mb-0 btn-green children width-100`} onClick={() => onView(rowData)}>View</button>
      </div>
    </Cell>
  )
}

const JoinedDomainComponent = () => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { joinedDomains, isLoading, currentDomain }
  } = store

  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)
  const [selectedDomain, setSelectedDomain] = useState({})
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const columns = [
    {
      label: 'No.',
      name: 'serialNo'
    },
    {
      label: 'Domain Name',
      name: 'domainName'
    },
    {
      label: 'Company Name',
      name: 'companyName'
    },
    {
      label: 'Owner',
      name: 'companyName'
    },
    {
      label: 'Status',
      name: 'status'
    }
  ]

  const domainColumns = [
    {
      label: 'Domain Name',
      value: 'domainName',
    },
    {
      label: 'Company Name',
      value: 'companyName',
    },
    {
      label: 'Address 1',
      value: 'address1',
    },
    {
      label: 'Address 2',
      value: 'address2',
    },
    {
      label: 'City',
      value: 'city',
    },
    {
      label: 'State',
      value: 'state',
    },
    {
      label: 'Zip',
      value: 'zip',
    },
    {
      label: 'Country',
      value: 'country',
    },
    {
      label: 'URL',
      value: 'url',
    },
    {
      label: 'Phone',
      value: 'phone',
    },
    {
      label: 'Industry',
      value: 'industry',
    },
    {
      label: 'Company Size',
      value: 'companySize',
    },
  ]

  const roleOptions = [
    {
      label: 'User',
      value: 1,
    },
    {
      label: 'Moderator',
      value: 2,
    },
    {
      label: 'Admin',
      value: 3,
    },
  ]

  const handleShowDetailModal = (domain) => {
    setSelectedDomain(domain)
    setShowDetailModal(true)
  }

  const handleCloseDetailModal = () => {
    setShowDetailModal(false)
  }

  const handleShowInviteModal = (domain) => {
    setSelectedDomain(domain)
    setShowInviteModal(true)
  }

  const handleCloseInviteModal = () => {
    setShowInviteModal(false)
  }

  useEffect(() => {
    dispatch(
      doGetJoinedDomainsByUserId()
    )
  }, [dispatch])

  const headerElement = columns.map((h, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          key={h.name}
          width={50}
        >
          <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
          <TableCell dataKey={h.name} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        key={h.name}
      >
        <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
        <TableCell dataKey={h.name} />
      </Column>
    )
  })

  const paginatedData = joinedDomains?.sort((a, b) => {
  }).slice(limit * (page - 1), limit * page)

  return (
    <div className={`joineddomain-component mt-5 ${isLoading ? 'loading' : ''}`}>
      {/* {isLoading && <LoaderComponent />} */}
      <div className="header">
        <div className="title">
          <h2 className='fw-bold text-blue'>Joined Users</h2>
        </div>
      </div>
      <div className='shadow mt-4 border border-2 rounded'>
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          data={paginatedData}
        >
          {headerElement}
          <Column
            width={250}
            fixed="right"
            key="action"
          >
            <HeaderCell className='h4 mb-0 text-black fw-bold'>Action</HeaderCell>
            <SelectorCell
              onView={handleShowDetailModal}
              onInvite={handleShowInviteModal}
              isAdminOrModerator={isAdminOrModerator}
            />
          </Column>
        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={joinedDomains.length}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { setPage(event) }}
            onChangeLength={(limit) => { setLimit(limit) }}
          />
        </div>
      </div>
      {/* <div className="content">
        <div className="table">
          <div className="table-header table-row">
            <div className="no table-col">
              No
            </div>
            <div className="table-col">
              Domain Name
            </div>
            <div className="table-col">
              Company Name
            </div>
            <div className="table-col">
              Owner
            </div>
            <div className="table-col">
              Status
            </div>
            <div className="table-col">
              Action
            </div>
          </div>
          <div className="table-body overflow-auto">
            {
              joinedDomains && joinedDomains.length > 0 ? joinedDomains.map((domain, index) => (
                <div className={`table-row`} key={domain.id}>
                  <div className="no table-col text-break">
                    {index + 1}
                  </div>
                  <div className="table-col text-break">
                    {domain.domainName}
                  </div>
                  <div className="table-col text-break">
                    {domain.companyName}
                  </div>
                  <div className="table-col text-break">
                    {domain.companyName}
                  </div>
                  <div className="table-col text-break">
                    {domain?.userRole?.role?.name}
                  </div>
                  <div className="table-col text-break">
                    <button type="button" className="btn btn-blue" onClick={() => handleShowDetailModal(domain)}>
                      View
                    </button>
                    {
                      domain.isActive && (
                        <button type="button" className="btn btn-blue" onClick={() => handleShowInviteModal(domain)}>
                          Invite
                        </button>
                      )
                    }
                  </div>
                </div>
              )) : (
                <div className={`table-row`}>
                  No Data
                </div>
              )
            }
          </div>
        </div>
      </div> */}

      <DomainDetailModal
        show={showDetailModal}
        onClose={handleCloseDetailModal}
        domainColumns={domainColumns}
        selectedDomain={selectedDomain}
      />
      <DomainInviteModal
        show={showInviteModal}
        onClose={handleCloseInviteModal}
        roleOptions={roleOptions}
        selectedDomain={selectedDomain}
      />
    </div>
  )
}

export default JoinedDomainComponent

